import type { IconButtonProps } from "@mui/material";
import { IconButton } from "@mui/material";
import type { ChangeEvent, FC } from "react";
import { useTranslation } from "react-i18next";
import { AppPopover } from "../../../../common/AppPopover";
import { usePopover } from "../../../../common/hooks/use-popover";
import { AppInput } from "../../../../shared/components/AppInput";
import { EditIcon } from "../../../../shared/icons/EditIcon";
import styles from "./styles.module.css";

interface Props extends IconButtonProps {
  name: string;
  onEditName: () => void;
  handleNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onCancel: () => void;
}

export const ObjectNameChange: FC<Props> = ({
  name,
  onEditName,
  handleNameChange,
  onCancel,
  ...props
}) => {
  const {
    anchorPopoverEl,
    openPopover,
    handleOpenPopover,
    handleClosePopover,
  } = usePopover();
  const { t } = useTranslation();
  return (
    <>
      <IconButton
        className={styles["action-button"]}
        onClick={handleOpenPopover}
        {...props}
      >
        <EditIcon />
      </IconButton>
      <AppPopover
        anchorEl={anchorPopoverEl}
        handleClose={() => {
          onCancel();
          handleClosePopover();
        }}
        onOk={() => {
          onEditName();
          handleClosePopover();
        }}
        open={openPopover}
      >
        <AppInput
          value={name}
          placeholder={t("versioning.change_name_popover_placeholder")}
          onChange={handleNameChange}
        />
      </AppPopover>
    </>
  );
};
